import React from "react";
import { RenderIf, ChangeLink } from "../modals/SummaryModal";
import './BoxHeader.scss';
import { _t } from "../utils/Lang";

export function BoxHeader({ children, showButtons = false, anchor = null }) {
    return <div className="BoxHeader mt-3 mb-2">
        <div>
            <p className="c-h3 m-0">{children}</p>
        </div>
        <div className="ms-auto">
            <RenderIf condition={showButtons}>
                <div className="d-flex w-100 j-end a-end">
                    <ChangeLink
                        className="btn-link"
                        type="button"
                        anchor={anchor}>{_t("change_selection")}</ChangeLink>
                </div>
            </RenderIf>
        </div>
    </div>;
}
